<template>
    <div id="singleChild">
      <template v-if="isDisplayLocation">
        <v-layout class="flex-column">
          <v-layout class="mt-2 mb-3">
            <v-flex>
              <v-btn fab absolute left class="ml-3 pf-btn-fab" @click="isDisplayLocation = false">
                <v-icon>arrow_back</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs12 class="text-xs-right">
              <v-btn class="pf-btn pf-btn-grey border-radius-10 box-shadow-none" @click="isDisplayLocation = false">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
            </v-flex>
          </v-layout>
          
          <v-layout class="flex-column px-2">
            <h3 class="mt-4 pf-font-16 font-weight-bold">Display Locations</h3>
            <v-layout wrap>
              <v-flex sm3>
                <v-select v-model="displayState" label="Filter by state" :items="[...['All'], ...displayedStates]" @change="filterDisplayLocations"></v-select>
              </v-flex>
            </v-layout>
            <v-data-table :headers="displayLocationHeaders" :items="displayLocations" class="mt-4 pf-data-table">
              <template v-slot:items="props">
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.address && props.item.address.length ? props.item.address[0].state.name : '--' }}</td>
                <td>
                  <a v-if="props.item.website" :href="`${props.item.website.indexOf('http') === -1 ? 'https://' : ''}${props.item.website}`" target="_blank">{{ props.item.website }}</a>
                  <span v-else>--</span>
                </td>
                <!-- <td>
                  <v-select
                  :disabled="props.item.is_owner"
                  v-model="props.item.other_children.find(x => x.child === parentData.id).status"
                  :items="['Disabled', 'Enabled']"
                  @change="changeDisplayStatus(props.item)"
                  :readonly="readonly"
                  ></v-select>
                </td> -->
              </template>
          
            </v-data-table>
          </v-layout>
        </v-layout>
      </template>
      <template v-else-if="isDisplayInquiries">
        <child-inquiries :child="parentData" :data="inquiries" @back="isDisplayInquiries = false" />
      </template>
      <template v-else-if="child">
        <v-layout class="mt-2 mb-3">
          <v-flex>
            <v-btn fab absolute left class="ml-3 pf-btn-fab" @click="cancel">
              <v-icon>arrow_back</v-icon>
            </v-btn>
          </v-flex>
          <v-flex xs12 class="text-xs-right">
            <v-btn class="pf-btn pf-btn-grey border-radius-10 box-shadow-none" @click="cancel">
              <v-icon size="16" class="pr-1">cancel</v-icon>
              <div>Cancel</div>
            </v-btn>
            <v-btn :disabled="!selectedData && currentPage === lastPage" class="pf-btn pf-bg-teal border-radius-10 box-shadow-none" @click="save" v-if="!readonly || currentPage !== 3">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>{{ currentPage === 3 ? 'Save' : 'Next' }}</div>
            </v-btn>
          </v-flex>
        </v-layout>

        <v-flex class="pt-3 flex-row" v-if="parentData.type === 'Individual'">
          <h3 class="px-2 pf-font-16 font-weight-bold mb-2">Choose a child type</h3>
          <v-radio-group v-model="parentData.type" row class="ma-0 px-2" @change="$emit('changedChildType')">
            <v-radio v-for="(type, j) in childrenTypes" :key="j" :label="`${type.text}`" :value="type.value" color="teal" :readonly="readonly"></v-radio>
          </v-radio-group>
        </v-flex>

        <v-layout class="flex-column">
            <v-layout wrap class="mt-2 flex-end-end">
              <v-flex xs12 sm4 class="my-2">
                <v-text-field v-model="child.case_id" label="Case ID (optional)" class="px-2" @input="changedData" :readonly="readonly"></v-text-field>
              </v-flex>
              <v-flex xs12 sm2></v-flex>
              <v-flex xs12 sm2 class="my-2 flex-column">
                <div class="cursor-pointer flex-align-center" @click="showDisplayLocations">
                  <v-icon class="pf-text-teal mr-2" size="24">pin_drop</v-icon>
                  <span class="pf-text-teal">Display Locations ({{ displayLocationsBackup.length || 0 }})</span>
                </div>
                <div class="mt-2 cursor-pointer flex-align-center" @click="showInquiries">
                  <v-icon class="pf-text-teal mr-2" size="24">sms</v-icon>
                  <span class="pf-text-teal">Inquiries ({{ inquiriesBackup.length }})</span>
                </div>
              </v-flex>
              <v-flex xs12 sm4 class="my-2 flex-center">
                <v-flex class="flex-center flex-column" v-if="child._id">
                  <v-hover v-slot="{ hover: individualAvatarHover }">
                    <div style="position:relative" class="border-radius-15 my-2">
                      <img v-if="child.avatar" class="border-radius-15" width="200" :src="child.avatar.replace('/thumb/', '/original/')" />
                      <img v-else class="border-radius-15" width="200" src="/static/profile-pic.jpg" />
                      <div v-if="!readonly && individualAvatarHover" class="border-radius-15 flex-center avatar-overlay" @click="changeAvatar">
                        <v-icon size="25" color="white">photo_camera</v-icon>
                      </div>
                    </div>
                  </v-hover>
                  <span>Photo</span>
                </v-flex>
              </v-flex>
            </v-layout>

            <v-flex class="child-section-header pf-bg-light-3 mt-4 py-4 px-3 flex-center border-radius-10">
              <span class="text-uppercase font-weight-bold pf-font-16">{{ childTab === 'childInfo' ? 'Child Information' : (childTab === 'contact' ? 'Contact Information' : 'Disablities & Risks') }}</span>
            </v-flex>

            <v-layout class="mt-4">
                <v-flex class="flex-space-around">
                    <div class="flex-column flex-center cursor-pointer" @click="switchTabs(1)">
                        <v-icon :color="childTab === 'childInfo' ? 'white' : 'black'" :class="{ 'pf-bg-teal': childTab === 'childInfo' }" class="pf-bg-light pa-3 border-radius-30 mb-2" size="20">settings</v-icon>
                        <span :class="{ 'font-weight-bold': childTab === 'childInfo' }">Child Information</span>
                    </div>
                    <div class="flex-column flex-center cursor-pointer" @click="switchTabs(2)">
                        <v-icon :color="childTab === 'contact' ? 'white' : 'black'" :class="{ 'pf-bg-teal': childTab === 'contact' }" class="pf-bg-light pa-3 border-radius-30 mb-2" size="20">contacts</v-icon>
                        <span :class="{ 'font-weight-bold': childTab === 'contact' }">Contact</span>
                    </div>
                    <div class="flex-column flex-center cursor-pointer" @click="switchTabs(3)">
                        <v-icon :color="childTab === 'disabilities' ? 'white' : 'black'" :class="{ 'pf-bg-teal': childTab === 'disabilities' }" class="pf-bg-light pa-3 border-radius-30 mb-2" size="20">assist_walker</v-icon>
                        <span :class="{ 'font-weight-bold': childTab === 'disabilities' }">Disabilities & Risks</span>
                    </div>
                </v-flex>
            </v-layout>

            <!-- Sections -->
            <v-layout v-if="childTab === 'childInfo'" class="mt-5 flex-column">

              <v-form ref="SingleChildInfo">

                <h3 class="mt-4 px-2 pf-font-16 font-weight-bold">Child Information</h3>
                <v-layout class="mt-2" wrap>
                  <v-flex xs12 sm4 class="my-2">
                      <v-text-field v-model.trim="child.human[0].first_name" :rules="[rules.required]" label="First Name" class="required px-2" @input="changedData" :readonly="readonly"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4 class="my-2">
                      <v-text-field v-model.trim="child.human[0].middle_name" label="Middle Name" class="px-2"
                      @input="changedData" :readonly="readonly"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4 class="my-2">
                      <v-text-field v-model="child.human[0].last_name" label="Last Name" class="px-2"
                      @input="changedData" :readonly="readonly"></v-text-field>
                  </v-flex>
                  <!-- <v-flex xs12 sm4 class="my-2">
                      <v-menu :ref="`child_birth_date`" v-model="child.picker" :close-on-content-click="false"
                      :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                      <template v-slot:activator="{ on }">
                          <v-text-field v-model="dobFormatted" label="Date of Birth" hint="MM/DD/YYYY" persistent-hint
                          :readonly="readonly" v-mask="'##/##/####'" type="tel" prepend-icon="event" v-on="on" :rules="[rules.required]"
                          class="required px-2"
                          @blur="child.human[0].birth_date = parseDate(dobFormatted); selectedData = true"
                          @input="selectedData = true"></v-text-field>
                      </template>
                      <v-date-picker v-if="!readonly" color="#019d8c" :max="new Date().toISOString().substr(0, 10)"
                          v-model="child.human[0].birth_date" @input="child.picker = false">
                      </v-date-picker>
                      </v-menu>
                  </v-flex> -->
                  <v-flex xs12 sm4 class="my-2">
                    <v-text-field v-model="child.human[0].age" label="Age" class="required px-2"
                      @input="changedData" :rules="rules.number" :readonly="readonly"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4 class="my-2">
                      <v-select v-model="child.human[0].gender" label="Gender" :rules="[rules.required]" class="required px-2" :items="genders" @change="changedData" :readonly="readonly"></v-select>
                  </v-flex>
                  <v-flex xs12 sm4 class="my-2">
                      <v-select v-model="child.human[0].ethnicity" :rules="[rules.required]" label="Race" class="required px-2" :items="ethnicities" @change="changedData" :readonly="readonly"></v-select>
                  </v-flex>
                  <v-flex xs12 sm4 class="my-2">
                      <v-select v-model="child.human[0].education" :small-chips="child.human[0].education !== ''" :deletable-chips="child.education !== ''" label="Education" class="px-2" :items="educations" @change="changedData" :readonly="readonly"></v-select>
                  </v-flex>
                  <v-flex xs12 sm4 class="flex-align-end my-2">
                    <v-select v-model="child.additional_info.legally_free" label="Legally Free" class="px-2" :items="yesOrNo" @change="changedData" :readonly="readonly"></v-select>
                  </v-flex>
                  <v-flex xs12 sm4 class="my-2">
                      <v-select v-model="child.additional_info.icwa" label="Does ICWA apply" class="px-2" :items="yesOrNo"
                      @change="changedData" :readonly="readonly"></v-select>
                  </v-flex>
                  <v-flex xs12 sm4 class="my-2">
                      <v-select v-model="child.additional_info.primary_language" label="Primary language" :rules="[rules.required]" class="required px-2" :items="languages" @change="changedData" :readonly="readonly"></v-select>
                  </v-flex>
                  <v-flex xs12 sm4 class="my-2">
                      <v-select v-model="child.additional_info.secondary_language" label="Secondary language" class="px-2" :items="languages" @change="changedData" :readonly="readonly"></v-select>
                  </v-flex>
                </v-layout>

                <v-layout class="mt-4" wrap v-if="parentData.type === 'Individual'">
                  <v-flex class="xs12 sm4 my-2">
                    <v-text-field label="City" class="px-2" v-model.trim="parentData.jurisdiction.city" @input="changedData" :readonly="readonly"></v-text-field>
                  </v-flex>
                  <v-flex class="xs12 sm4 my-2">
                    <v-text-field label="County" class="px-2" v-model.trim="parentData.jurisdiction.county" @input="changedData" :readonly="readonly"></v-text-field>
                  </v-flex>
                  <v-flex class="xs12 sm4 my-2">
                    <v-select class="px-2" v-model="parentData.status.status" label="Status" :items="childStatuses" @change="changedData" :readonly="readonly"></v-select>
                  </v-flex>
                </v-layout>

                <v-layout wrap>
                  <v-flex class="xs12 sm4 my-2">
                    <v-select class="px-2" v-model="child.placement" label="Placement" :items="placementTypes" @change="placementChanged" :readonly="readonly"></v-select>
                  </v-flex>
                  <v-flex class="xs12 sm4 my-2" v-if="['selectedStates', 'inState'].indexOf(child.placement) > -1">
                    <v-autocomplete label="Select the States" :disabled="child.placement === 'inState'" class="px-2" :items="filteredStates" item-value="id" item-text="name" v-model="child.display_on_states" multiple small-chips deletable-chips @change="changedData" :readonly="readonly"></v-autocomplete>
                  </v-flex>
                </v-layout>

                <v-layout class="mt-2" wrap>
                  <v-flex xs12 class="flex-align-end mt-3">
                      <v-radio-group label="Are there significant relationships the child must maintain?"
                      v-model="child.additional_info.keep_relationships" row class="px-2" :readonly="readonly">
                        <v-radio v-for="(type, j) in yesOrNo" :key="j" :label="`${type.text}`" :value="type.value" color="teal"></v-radio>
                      </v-radio-group>
                  </v-flex>
                  <v-flex xs12 sm6 class="my-2" v-if="child.additional_info.keep_relationships">
                      <v-text-field v-model.trim="child.additional_info.keep_relation_person"
                      label="With whom child must maintain relationships" class="px-2"
                      @input="changedData" :readonly="readonly"></v-text-field>
                  </v-flex>
                  <v-flex xs12 class="flex-align-end">
                      <v-radio-group label="Allergic to smoke?" v-model="child.additional_info.smoke_allergy" row class="px-2" :readonly="readonly">
                        <v-radio v-for="(type, j) in yesOrNo" :key="j" :label="`${type.text}`" :value="type.value" color="teal"></v-radio>
                      </v-radio-group>
                  </v-flex>
                  <v-flex xs12 class="flex-align-end">
                      <v-radio-group label="Will child's agency pay for private agency services?" v-model="child.additional_info.pay_private_services" row class="px-2" :readonly="readonly">
                        <v-radio v-for="(type, j) in [...[{ text: 'Check with child\'s worker', value: 'Check with child\'s worker'}], ...yesOrNo]" :key="j" :label="`${type.text}`" :value="type.value" color="teal"></v-radio>
                      </v-radio-group>
                  </v-flex>
                </v-layout>
                <v-layout wrap class="mt-2">
                  <v-flex xs12 sm6 class="my-2">
                      <v-autocomplete label="Child’s pet allergies (select all that apply)" class="px-2" :items="pets" v-model="child.additional_info.pets" multiple small-chips deletable-chips @change="changedData" :readonly="readonly"></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm6 class="my-2">
                      <v-autocomplete label="Adoption assistance eligibility" class="px-2" :items="eligibilities" v-model="child.additional_info.assistance_eligibility" multiple small-chips deletable-chips @change="changedData" :readonly="readonly"></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 class="mt-4 mb-2 flex-column">
                      <h3 class="px-2 pf-font-16 font-weight-bold mb-2">Allergies (food, medicine, etc.)</h3>
                      <v-flex class="px-2">
                        <editor :disabled="readonly" :options="editorOption" v-model="child.additional_info.allergies" :content="aboutContent" :init="{...init, ...{ placeholder: 'Allergies (food, medicine, etc.)', height: 150 }}" :api-key="config.tinymceEditorKey" @input="changedData" />
                      </v-flex>
                  </v-flex>
                </v-layout>
  
                <v-layout class="mt-4 flex-column">
                  <h3 class="px-2 pf-font-16 font-weight-bold">Describe the family composition best suited for this child</h3>
                  <v-layout wrap>
                    <v-flex xs12 sm6 class="my-2">
                      <v-select class="px-2" v-model="child.preference.parent_type" label="Parent type (select all that apply)" multiple small-chips deletable-chips :items="parentTypes" @change="changedData" :readonly="readonly"></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 class="my-2">
                      <v-select class="px-2" v-model="child.preference.other_children" label="Other children" :items="otherChildren" @change="changedData" :readonly="readonly"></v-select>
                    </v-flex>
                    <v-flex xs12 sm4 class="my-2">
                      <v-select class="px-2" v-model="child.preference.gender" label="Gender" :items="prefGenders" @change="changedData" :readonly="readonly"></v-select>
                    </v-flex>
                    <v-flex xs12 sm4 class="my-2">
                      <v-select class="px-2" v-model="child.preference.age" label="Age" :items="prefAges" @change="changedData" :readonly="readonly"></v-select>
                    </v-flex>
                    <v-flex xs12 sm4 class="my-2">
                      <v-select class="px-2" v-model="child.preference.religion" label="Religious preference" :items="prefReligions" @change="changedData" :readonly="readonly"></v-select>
                    </v-flex>
                  </v-layout>
                </v-layout>
                
                <v-layout class="mt-4 flex-column">
                  <h3 class="px-2 pf-font-16 font-weight-bold mb-2">Public Narrative</h3>
                  <v-flex sm12 class="px-2">
                    <editor :disabled="readonly" :options="editorOption" v-model="child.about" :content="aboutContent" :init="init" :api-key="config.tinymceEditorKey" @input="changedData" />
                  </v-flex>
                </v-layout>
  
                <!-- <v-layout class="mt-4 flex-column">
                  <h3 class="px-2 pf-font-16 font-weight-bold mb-2">Private Information</h3>
                  <v-flex sm12 class="px-2">
                    <editor :disabled="readonly" :options="editorOption" v-model="child.private_information" :content="aboutContent" :init="init" :api-key="config.tinymceEditorKey" @input="changedData" />
                  </v-flex>
                </v-layout>
  
                <v-layout class="mt-4 flex-column">
                  <h3 class="px-2 pf-font-16 font-weight-bold mb-2">For Professionals Only</h3>
                  <v-flex sm12 class="px-2">
                    <editor :disabled="readonly" :options="editorOption" v-model="child.for_professionals" :content="aboutContent" :init="init" :api-key="config.tinymceEditorKey" @input="changedData" />
                  </v-flex>
                </v-layout> -->
    
                <v-layout class="mt-4 flex-column" v-if="child._id">
                  <h3 class="px-2 mb-2 pf-font-16 font-weight-bold">photos</h3>
                  <v-layout wrap class="px-2" v-if="!readonly">
                    <v-flex xs10 class="pf-border-grey-dash-1 border-radius-15 pa-2 flex-center cursor-pointer" @click="uploadPhotos">
                      <v-flex class="flex-center flex-column">
                        <v-icon size="28" color="grey">add_photo_alternate</v-icon>
                        <span>Click here to upload</span>
                      </v-flex>
                    </v-flex>
                    <v-flex xs2 class="pl-3">
                      <v-flex class="flex-center pf-bg-teal border-radius-25 pa-4 cursor-pointer" @click="uploadPhotos">
                        <v-icon size="40" color="white">upload</v-icon>
                      </v-flex>
                    </v-flex>
                  </v-layout>
  
                  <!-- List photos -->
                  <v-layout class="mt-2">
                    <isotope ref="individualImages" v-if="individualPhotos.length" :options="getOptions()" v-images-loaded:on.progress="layout" :list="individualPhotos" class="pf-width-100p">
                      <v-flex v-for="(photo, p) in individualPhotos" :key="p" class="pa-2 photo-item xs6 sm3 md2">
                        <div class="border-radius-5 pf-cursor-pointer pf-pos-relative flex-center">
                          <v-card class="border-radius-5 pf-box-shadow">
                            <v-hover v-slot="{ hover: imageHover }">
                              <div class="pf-pos-relative">
                                <img class="pf-width-100p" :src="`${photo.thumb_url ? photo.thumb_url : photo.webview_url ? photo.webview_url : photo.original_url}`" :alt="photo.caption">
                                <v-btn absolute v-if="!readonly && imageHover && photo.status !== 'Approved'" title="Remove photo" icon flat @click.stop="deletePhoto(photo)" class="white top-right">
                                  <v-icon class="pf-text-teal" size="18">delete</v-icon>
                                </v-btn>
                              </div>
                            </v-hover>
                            <v-layout class="wrap flex-center">
                              <v-flex xs10 class="pa-1 flex-start">
                                <span v-if="!isCaptionEdit || currentEditPhoto !== photo.id" class="pf-font-12 pa-1 font-weight-regular">{{photo.caption || 'No Caption'}}</span>
                                <v-text-field v-if=" !readonly && isCaptionEdit && currentEditPhoto === photo.id" v-model.trim="photo.caption" autofocus :hide-details="true" class="pf-font-12 ma-0 pa-0" height="20" @keyup.enter.prevent="{}" @change="savePhotoCaption"></v-text-field>
                              </v-flex>
                              <v-flex xs2 class="text-center pa-1" v-if="!readonly">
                                <v-icon class="pf-text-teal" size="16" @click.stop="editPhotoCaption(photo, p)" v-if="!isCaptionEdit || currentEditPhoto !== photo.id">edit</v-icon>
                                <v-icon class="pf-text-teal" size="16" @click.stop="isCaptionEdit = false" v-else>done</v-icon>
                              </v-flex>
                            </v-layout>
                          </v-card>
                        </div>
                      </v-flex>
                    </isotope>
                  </v-layout>
                </v-layout>

              </v-form>

              <v-layout v-if="child._id">
                <!-- Videos -->
                <v-layout class="flex-column mt-4">
                  <h3 class="px-2 pf-font-16 font-weight-bold mb-2">Videos</h3>
                  <v-form ref="videoAddForm" v-if="!readonly">
                    <v-layout wrap class="px-2">
                      <v-flex xs10 sm6>
                        <v-text-field label="Provide YouTube or Vimeo video link" v-model="video.url" :rules="[videoLinkRule]"></v-text-field>
                      </v-flex>
                      <v-flex xs2 sm2>
                        <v-btn class="border-radius-15 pf-btn pf-btn-save pf-bg-teal" @click="addVideo">
                          <v-icon size="18" class="pr-2">add</v-icon>
                          <div>Add</div>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-form>
                  <v-layout wrap class="mt-3">
                    <v-flex xs12 sm3 v-for="videoItem of individualVideos" :key="videoItem.id" pa-2 class="video-listing">
                      <v-card v-if="videoItem.url" height="100%" class="pf-pos-relative">
                        <youtube v-if="videoItem.type === 'Youtube'" class="youtube-player" :video-id="getIdFromURL(videoItem.url)">
                        </youtube>
                        <vimeo-player v-else-if="videoItem.type === 'Vimeo'" :video-url="videoItem.url" class="vimeo-embed-container" :options="{ responsive: true, controls: true, title: false }"></vimeo-player>
                        <video v-else playsinline controls height="150" width="100%">
                          <source :src="videoItem.url" />
                        </video>
                        
                        <v-flex class="pl-1 pr-1 mb-0">
                          <h5 v-if="!isVideoCaptionEdit || currentEditVideo != videoItem.id" id="videoName" class="pa-1 title-display">
                            <div v-on:click="!readonly ? $emit('editVideo', videoItem, videoItem.id) : {}">
                              <span v-if="videoItem.name">{{ videoItem.name }}</span>
                              <span v-else>Add title here</span>
                            </div>
                          </h5>
                          <v-text-field 
                            v-if="!readonly && isVideoCaptionEdit && currentEditVideo == videoItem.id" 
                            v-model.trim="videoItem.name"
                            autofocus 
                            :hide-details="true"
                            class="pr-1 pt-1 text-edit-field" 
                            height="20" 
                            placeholder="Add title here"
                            @change="updateVideoTitle">
                          </v-text-field>
                        </v-flex>
                        <v-divider horizontal></v-divider>
                        <v-flex flat class="text-xs-right pa-1" v-if="!readonly">
                          
                          <v-btn icon title="Cancel Edit" class="ma-0 handle" v-show="isVideoCaptionEdit && currentEditVideo == videoItem.id" @click="$emit('cancelVideoEdit')">
                            <v-icon size="22" color="grey darken-2">cancel</v-icon>
                          </v-btn>
                          <v-btn icon title="Edit" class="ma-0" :disabled="isVideoCaptionEdit && currentEditVideo == videoItem.id" @click="$emit('editVideo', videoItem, videoItem.id)">
                            <v-icon size="22" color="grey darken-2">edit</v-icon>
                          </v-btn>
                          <v-btn icon title="Delete" class="ma-0" v-on:click="$emit('deleteVideo', videoItem, 'individual');">
                            <v-icon size="22" color="grey darken-2">delete_outline</v-icon>
                          </v-btn>
                        </v-flex>
                        
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-layout>

            </v-layout>

            <v-layout v-else-if="childTab === 'contact' && child.contact" class="mt-5 flex-column">
              <h3 class="px-2 pf-font-16 font-weight-bold">Professional Inquire</h3>

              <v-form ref="SingleChildContact">
                <v-layout wrap>
                  <v-flex xs12 sm4 class="my-2">
                    <v-text-field v-model.trim="child.contact.name" :class="{ 'required': parentData.type === 'Individual' }" label="Contact Name" class="px-2" @input="changedData" :rules="parentData.type === 'Individual' ? [(v) => !!v || 'Please enter contact name'] : []" :readonly="readonly"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4 class="my-2">
                    <v-text-field v-model.trim="child.contact.organization" label="Organization" class="px-2" @input="changedData" :readonly="readonly"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4 class="my-2">
                    <v-text-field v-mask="'(###) ###-####'" placeholder="(###) ###-####" label="Phone Number"
                      v-model.trim="child.contact.phone" @input="changedData" :rules="[rules.phoneRules]" class="px-2" :readonly="readonly"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4 class="my-2">
                    <v-text-field label="Email Address" :class="{ 'required': parentData.type === 'Individual' }" v-model="child.contact.email" class="px-2" :rules="parentData.type === 'Individual' ? [rules.blankRules, rules.emailRules] : [rules.emailRules]" data-vv-name="emailAddress" @input="changedData" :readonly="readonly"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4 class="my-2">
                    <v-text-field label="Website URL" hint="Ex: https://example.com, http://example.com" v-model="child.contact.website" class="px-2" :rules="rules.websiteRules" data-vv-name="websiteAddress" @input="changedData" :readonly="readonly"></v-text-field>
                  </v-flex>
                </v-layout>
  
                <v-layout class="mt-5 flex-column">
                  <h3 class="px-2 pf-font-16 font-weight-bold">Website Inquire</h3>
                  <v-layout wrap>
                    <v-flex xs12 sm8 class="my-2">
                      <div class="mt-3 px-2 font-weight-light pf-font-16" v-if="session.role() !== 'admin'">{{ Agency.name }}</div>
                      <v-autocomplete v-else label="Organization" :class="{ 'required': parentData.type === 'Individual' }" class="px-2" item-text="name" item-value="id" :disabled="parentData.type === 'Sibling'" :items="AgencyList" return-object v-model="parentData.agency" @change="fetchAgencyData()" :readonly="readonly">
                      </v-autocomplete>
                    </v-flex>
                  </v-layout>
                </v-layout>
  
                <v-layout class="mt-2 flex-column">
                  <!-- <v-layout wrap>
                    <v-flex class="xs12 sm4 my-2">
                      <v-text-field label="Name" v-model.trim="parentData.agency_contact"
                        class="px-2" @input="changedData" :readonly="readonly">
                      </v-text-field>
                    </v-flex>
                    <v-flex class="xs12 sm4 my-2">
                      <v-text-field label="Address Line 1" :disabled="parentData.type !== 'Individual'" v-model.trim="agencyAddress.line_1"
                        class="px-2" @input="changedData($event, true)" :readonly="readonly">
                      </v-text-field>
                    </v-flex>
                    <v-flex class="xs12 sm4 my-2">
                      <v-text-field label="Address Line 2" :disabled="parentData.type !== 'Individual'" v-model="agencyAddress.line_2" @input="changedData($event, true)"
                        class="px-2" :readonly="readonly">
                      </v-text-field>
                    </v-flex>
                    <v-flex class="xs12 sm4 my-2">
                      <v-text-field label="City" :disabled="parentData.type !== 'Individual'" class="px-2" v-model.trim="agencyAddress.city"
                        @input="changedData($event, true)" :readonly="readonly">
                      </v-text-field>
                    </v-flex>
                    <v-flex class="xs12 sm4 my-2">
                      <v-autocomplete label="Country" :disabled="parentData.type !== 'Individual'" class="px-2" item-text="name" item-value="id" :items="Country" v-model="agencyAddress.country" @change="changedData($event, true)" :readonly="readonly">
                      </v-autocomplete>
                    </v-flex>
                    <v-flex class="xs12 sm4 my-2">
                      <v-autocomplete label="State" :disabled="parentData.type !== 'Individual'" :items="filteredStates" item-value="id" item-text="name"
                        no-data-text="No data available" class="px-2"
                        @change="changedData($event, true)" v-model="agencyAddress.state" :readonly="readonly">
                      </v-autocomplete>
                    </v-flex>
                    <v-flex class="xs12 sm4 my-2">
                      <v-text-field label="Zip Code" :disabled="parentData.type !== 'Individual'" v-mask="'#####'" placeholder="#####" v-model="agencyAddress.zip"
                        class="px-2" @input="changedData($event, true)" :readonly="readonly">
                      </v-text-field>
                    </v-flex>
                    <v-flex class="xs12 sm4 my-2">
                      <v-text-field label="Email Address" :disabled="parentData.type !== 'Individual'" v-model="agencyAddress.email"
                        @blur="duplicateEmailChecking" class="px-2"
                        :rules="[rules.emailRules]" data-vv-name="emailAddress"
                        :readonly="readonly"
                        @input="changedData($event, true)">
                      </v-text-field>
                    </v-flex>
                    <v-flex class="xs12 sm4 my-2">
                      <v-text-field v-mask="'(###) ###-####'" :disabled="parentData.type !== 'Individual'" placeholder="(###) ###-####" label="Phone Number"
                        v-model="agencyAddress.phone" @input="changedData($event, true)" :rules="[rules.phoneRules]"
                        class="px-2" :readonly="readonly">
                      </v-text-field>
                    </v-flex>
                    <v-flex class="xs12 sm4 my-2">
                      <v-text-field label="Website URL" :disabled="parentData.type !== 'Individual'" hint="Ex: https://example.com, http://example.com"
                        v-model="agencyAddress.website" class="px-2" :rules="rules.websiteRules"
                        data-vv-name="websiteAddress" @input="changedData($event, true)" :readonly="readonly">
                      </v-text-field>
                    </v-flex>
                  </v-layout> -->
                  <v-layout wrap>
                    <v-flex xs12 sm4 class="my-2">
                      <v-text-field v-model.trim="child.website_contact.name" :rules="[rules.required]" label="Contact Name" class="required px-2" @input="changedData" :readonly="readonly"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm4 class="my-2">
                      <v-text-field v-model.trim="child.website_contact.organization" label="Organization" class="px-2" @input="changedData" :readonly="readonly"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm4 class="my-2">
                      <v-text-field v-mask="'(###) ###-####'" placeholder="(###) ###-####" label="Phone Number"
                        v-model.trim="child.website_contact.phone" @input="changedData" :rules="[rules.phoneRules]" class="px-2" :readonly="readonly"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm4 class="my-2">
                      <v-text-field label="Email Address" v-model="child.website_contact.email" class="required px-2" :rules="[rules.required, rules.emailRules]" v-validate="'required'" data-vv-name="emailAddress" @input="changedData" :readonly="readonly"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm4 class="my-2">
                      <v-text-field label="Website URL" hint="Ex: https://example.com, http://example.com" v-model="child.website_contact.website" class="px-2" :rules="rules.websiteRules" data-vv-name="websiteAddress" @input="changedData" :readonly="readonly"></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-layout>

              </v-form>

            </v-layout>

            <v-layout v-else-if="childTab === 'disabilities'" class="mt-5 flex-column">
              <h3 class="px-2 pf-font-16 font-weight-bold">Disablities & Risks</h3>
              <v-form ref="SingleChildRisks">
                
                <v-layout class="px-2 flex-column">
                  <v-flex class="flex-column flex-align-start grey--text text--darken-2 mb-3">
                    <h5 class="mt-3 mb-2 pf-font-16 font-weight-medium">Select only:</h5>
                    <span>1. Physical, developmental, and learning disabilities that are current (i.e. occurring in the last
                      year or are ongoing) and have been diagnosed by a licensed provider</span>
                    <span>2. Behavioral challenges that a child is currently exhibiting</span>
                  </v-flex>
                  <v-flex class="flex-column flex-align-start grey--text text--darken-2 mb-4">
                    <h5 class="mt-3 mb-2 pf-font-16 font-weight-medium">Displaying disabilities:</h5>
                    <span>Full details on risk factors and disabilities are available to all child and family workers
                      registered, and only available to registered families at your discretion.</span>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex xs12 class="px-2 my-2">
                    <div class="flex-column flex-align-start">
                      <v-radio-group :rules="[rules.required]" @change="changedData" v-model="child.additional_info.disability.display" label="Access for registered families" class="ma-0 pa-0" :readonly="readonly">
                        <v-radio v-for="(access, j) in disabilityAccess" color="teal" :key="j" :label="`${access}`" :value="access"></v-radio>
                      </v-radio-group>
                    </div>
                  </v-flex>
                  <v-flex xs12 class="my-2">
                    <v-autocomplete label="Risk factors" class="px-2" :items="risks" v-model="child.additional_info.disability.risks" multiple small-chips deletable-chips @change="changedData" :readonly="readonly"></v-autocomplete>
                  </v-flex>
                  <v-flex class="flex-column flex-align-start grey--text text--darken-2 mb-2 mt-4">
                    <h3 class="px-2 pf-font-16 font-weight-bold mb-3">Types of Disabilities</h3>
                    <div class="px-2 flex-column flex-align-start pf-width-100p" v-for="(disability, d) in disabilities" :key="d">
                      <v-radio-group :rules="[rules.required]" v-model="child.additional_info.disability.types[disability].value" :label="disability" class="ma-0 pa-0" @change="(child.additional_info.disability.types[disability].value === 'None' ? child.additional_info.disability.types[disability].items = [] : ''); changedData()" :readonly="readonly">
                        <v-layout class="flex-column">
                          <div class="flex-row">
                            <v-radio v-for="(type, j) in disabilityTypes" color="teal" :key="j" :label="`${type}`" :value="type"></v-radio>
                          </div>
                        </v-layout>
                      </v-radio-group>
                      <v-layout class="px-2 mb-4 pf-width-100p" v-if="child.additional_info.disability.types[disability].value !== 'None'" wrap>
                        <v-flex sm12>
                          <v-autocomplete label="Please choose disabilities" class="px-2" :items="disabilityItems" v-model="child.additional_info.disability.types[disability].items" multiple small-chips deletable-chips @change="changedData" :readonly="readonly"></v-autocomplete>
                        </v-flex>
                        <v-flex sm3 v-if="child.additional_info.disability.types[disability].items.indexOf('Other') > -1">
                          <v-text-field label="Specify other" class="px-2" @input="changedData" @blur="addOtherDisability($event, child, disability)" :readonly="readonly"></v-text-field>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-flex>
                </v-layout>

              </v-form>
            </v-layout>
            
            <v-layout class="mt-5">
              <v-flex xs12 class="text-xs-right">
                <v-btn class="pf-btn pf-btn-grey border-radius-10 box-shadow-none" @click="cancel">
                  <v-icon size="16" class="pr-1">cancel</v-icon>
                  <div>Cancel</div>
                </v-btn>
                <v-btn :disabled="!selectedData && currentPage === lastPage" class="pf-btn pf-bg-teal border-radius-10 box-shadow-none" @click="save" v-if="!readonly || currentPage !== 3">
                  <v-icon size="16" class="pr-1">check_circle</v-icon>
                  <div>{{ currentPage === 3 ? 'Save' : 'Next' }}</div>
                </v-btn>
              </v-flex>
            </v-layout>

        </v-layout>
      </template>
    </div>
</template>
    
<script>
/* global session store config */
import Vue from 'vue';
import { getCollection, remove, update, validateUrl, getOne, checkIfNoPFUrl, formatDate, isObjectEmpty, calculateAge } from '../../helpers/helpers';
import Editor from '@tinymce/tinymce-vue';
import swal from 'sweetalert2';
import { mask } from 'vue-the-mask';
import isotope from '../../components/Isotope';
import imagesLoaded from 'vue-images-loaded';
import VueYouTubeEmbed from 'vue-youtube-embed';
import ChildInquiries from './Inquiries.vue';
Vue.use(VueYouTubeEmbed);

import { vueVimeoPlayer } from 'vue-vimeo-player';

export default {
  directives: { mask, imagesLoaded },
  components: {
    Editor,
    isotope,
    imagesLoaded,
    'vimeo-player': vueVimeoPlayer,
    'child-inquiries': ChildInquiries
  },
  props: [
    'child',
    'parentData',
    'individualPhotos',
    'individualVideos',
    'video',
    'getIdFromURL',
    'currentEditVideo',
    'isVideoCaptionEdit',
    'videoLinkRule',
    'displayLocationsList',
    'inquiryList',
    'additionalInfo',
    'websiteContact',
    'professionalContact'
  ],
  data () {
    return {
      childTab: 'childInfo',
      formatDate,
      isAgencyContactInfoChanged: false,
      childBackup: {},
      agencyAddress: {
        line_1: '',
        line_2: '',
        city: '',
        country: '',
        state: '',
        zip: '',
        email: '',
        phone: '',
        website: '',
      },
      isCaptionEdit: false,
      currentEditPhoto: null,
      currentEditPhotoIndex: -1,
      editPhotoItem: null,
      emailFlag: false,
      rulesAgency: [
        v => !!v || 'Agency is required'
      ],
      rules: {
        required: value => !!value || 'Field is required.',
        blankRules: (v) => !!v && v.trim().length > 0 || 'Field is required',
        emailRules: (v) => !v || /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,8})+$/.test(v) || 'Please enter valid email address',
        zipRules: (v) => v === undefined || v === '' || /^([0-9]{5}|[0-9]{6})(?:-[0-9]{4})?$/.test(v) || 'Please enter valid zip code',
        phoneRules: (v) => v === undefined || v === '' || /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/.test(v) || 'Please enter valid phone number',
        websiteRules: [
          (v) => v === undefined || v === '' || (validateUrl(v)) || 'Please enter valid URL',
          v => !v || checkIfNoPFUrl(v) || 'The entered URL is not valid for campaigns'
        ],
        number: [
          v => !!v || 'Enter the age',
          v => Number.isInteger(Number(v)) || 'Age should be an integer'
        ],
        caseIdRule: [
          v => !!v || 'Case ID is required.',
          // (v) => !v || vm.checkIfCaseIdUnique(v) || 'The case Id is already exists'
        ],
      },
      ethnicities: ['American Indian/Alaskan Native', 'Asian', 'Black/African American', 'Hispanic/Latino', 'Pacific Islander/Native Hawaiian', 'Unable to determine', 'White/Caucasian'],
      educations: ['Unknown', '1st Grade', '2nd Grade', '3rd Grade', '4th Grade', '5th Grade', '6th Grade', '7th Grade', '8th Grade', '9th Grade', '10th Grade', 'Other'],
      genders: ['Male', 'Female', 'Female to Male', 'Male to Female', 'In Transition', 'Other', 'Unknown'],
      dataTabsModel: 'data-tabs-model',
      commonTabsModel: 'common-tabs-model',
      yesOrNo: [{ text: 'Yes', value: true }, { text: 'No', value: false }],
      languages: ['English', 'Spanish', 'Russian', 'French', 'None'],
      pets: ['Cats', 'Dogs', 'Other'],
      eligibilities: ['Ongoing financial assistance', 'Ongoing medical assistance', 'Ongoing mental health assistance', 'Non-recurring adoption costs', 'Check with child\'s worker'],
      parentTypes: ['2 parents', '1 female parent', '1 male parent'],
      otherChildren: ['No preference', 'No other children', 'Must have other children'],
      prefGenders: ['No preference', 'Male only', 'Female only'],
      prefAges: ['No preference', 'Must be oldest', 'Must be youngest'],
      prefReligions: ['Anglican', 'Atheist', 'Bahai', 'Baptist', 'Buddhist', 'Catholic', 'Christian', 'Church of Christ', 'Episcopal', 'Hindu', 'Jewish', 'Lutheran', 'Mormon', 'Methodist', 'Muslim', 'None', 'Non-denominational', 'Other', 'Presbyterian', 'Protestant', 'The Church of Jesus Christ of Latter-Day Saints', 'Unitarian'],
      disabilityAccess: ['Do not display any information about disabilities or risk factors', 'Display only the overall levels without specific details', 'Display everything, overall levels and specific details'],
      risks: ['Alcohol exposed', 'Domestic-violence exposed', 'Drug exposed—in home', 'Failure to thrive', 'History of abuse or neglect', 'History of multiple placements', 'Intellectual disability in birth family', 'Mental illness in birth family', 'Premature birth', 'Schizophrenia in birth family', 'Sexual abuse'],
      disabilities: ['Overall level of physical disability', 'Overall level of emotional disability', 'Overall level of behavioral disability', 'Overall level of developmental disability', 'Overall level of learning disability'],
      disabilityTypes: ['None', 'Mild', 'Moderate', 'Severe'],
      disabilityItems: ['Allergies', 'Anemia', 'Asthma', 'Attention deficit hyperactivity disorder', 'Blindness—permanent', 'Cancer', 'Cerebral palsy', 'Craniofacial anomalies', 'Cystic fibrosis', 'Deaf—profound hearing loss', 'Diabetes', 'Dwarfism', 'Encopresis', 'Enuresis, or bedwetting', 'Epilepsy', 'Fetal alcohol spectrum disorder (FASD)', 'Fetal alcohol syndrome', 'Hearing loss', 'Heart defect', 'Hydrocephalus', 'Irritable bowel syndrome', 'Kidney disease', 'Limb loss', 'Microcephaly', 'Muscular dystrophy', 'Neurofibromatosis', 'Paralysis—paraplegic', 'Paralysis—quadriplegic', 'Respiratory problems', 'Scoliosis', 'Seizure disorders', 'Sickle cell anemia', 'Sickle cell trait', 'Speech disorders', 'Spina bifida', 'Terminal illness', 'Tourette syndrome', 'Visually impaired', 'Wheelchair dependent', 'Other'],
      selectedStates: [],
      childStatuses: ['Active', 'On Hold', 'Family Matched'],
      placementTypes: [
        { text: 'In State Only', value: 'inState' },
        { text: 'No Restrictions', value: 'anyWhere' },
        { text: 'Selected States', value: 'selectedStates' }
      ],
      childrenTypes: [
        { text: 'Individual', value: 'Individual' },
        { text: 'Sibling Group', value: 'Sibling' }
      ],
      currentPage: 1,
      lastPage: 3,
      formNames: {
        1: 'SingleChildInfo',
        2: 'SingleChildContact',
        3: 'SingleChildRisks'
      },
      childTabs: {
        1: 'childInfo',
        2: 'contact',
        3: 'disabilities'
      },
      displayLocationHeaders: [
        { text: 'Organization Name', value: 'organizationName', width: '20%' },
        { text: 'State', value: 'state', width: '20%' },
        { text: 'Website URL', value: 'websiteUrl', width: '20%' },
        // { text: 'Status', value: 'status', width: '20%' }
      ],
      isDisplayLocation: false,
      displayLocations: [],
      displayLocationsBackup: [],
      displayState: 'All',
      isDisplayInquiries: false,
      inquiries: [],
      inquiriesBackup: [],

      selectedData: false,
      session: session,
      config: config,
      dobFormatted: null,
      editorOption: {
        placeholder: 'Add text here..',
      },
      aboutContent: '',
      init: {
        height: 250,
        selector: 'blogTextEditor',
        placeholder: 'Add the text here',
        menubar: false,
        plugins: [''],
        toolbar: ''
      },
      readonly: false
    };
  },
  computed: {
    filteredStates () {
      let countryId = this.agencyAddress.country ? this.agencyAddress.country : '5f0af2eb1b61360afbb1aa0c';
      let options = this.State;
      return countryId ? options.filter(o => o.country.id === countryId) : [];
    },
    displayedStates () {
      return this.displayLocationsBackup.filter(agency => agency.address && agency.address.length).map(agency => agency.address[0].state.name) || [];
    },
    states () {
      return this.State.filter(o => o.country.id === '5f0af2eb1b61360afbb1aa0c');
    },
    Agency: {
      get () {
        return store.state.Agency;
      },
      set (value) {
        store.commit('setAgency', value);
      }
    },
    Country: {
      get () {
        return store.state.Country;
      },
      set (value) {
        store.commit('setCountry', value);
      }
    },
    State: {
      get () {
        return store.state.State;
      },
      set (value) {
        store.commit('setState', value);
      }
    },
    AgencyList: {
      set (value) {
        store.commit('setAgencyList', value);
      },
      get () {
        return store.state.AgencyList;
      }
    }
  },
  watch: {
    child: {
      handler: function (after, before) {
        if (this.child && this.child.human && this.child.human[0].birth_date) {
          this.dobFormatted = this.formatDateLocal(this.child.human[0].birth_date);
        }
      },
      deep: true
    }
  },
  // eslint-disable-next-line
  created () {
    this.initialize();
    /* Take the backup */
    this.childBackup = JSON.parse(JSON.stringify(this.child));
    if (this.child.human[0] && this.child.human[0].birth_date) {
      this.dobFormatted = this.formatDateLocal(this.child.human[0].birth_date);
      if (typeof this.child.human[0].age === 'undefined') {
        this.child.human[0].age = calculateAge(this.child.human[0].birth_date);
      }
    }

    /* Set readonly */
    if (this.$route.params.id && !this.Agency.is_super_admin && !this.Agency.child.find(x => x.child === this.parentData.id)) {
      this.readonly = true;
    }

    if (this.child.agencyAddress) {
      this.agencyAddress = this.child.agencyAddress;
    }
    /* Setup the inherited data */
    if (!this.child.preference || !Object.keys(this.child.preference).filter(pref => this.child.preference[pref].length).length) {
      this.child.preference = { ...this.parentData.preference };
    }

    if (!this.child.additional_info && this.additionalInfo) {
      this.child.additional_info = this.additionalInfo;
    }
    this.child.additional_info = {
      ...this.additionalInfo,
      ...this.child.additional_info
    };

    if (isObjectEmpty(this.child.contact)) {
      this.child.contact = { ...this.professionalContact };
    }

    if (isObjectEmpty(this.child.website_contact)) {
      this.child.website_contact = { ...this.websiteContact };
    }

    if (!this.child.placement) {
      this.child.placement = this.parentData.placement;
      this.child.display_on_states = this.parentData.display_on_states;
    }
    this.$emit('fetchPhotos', 'individual');
    this.$emit('fetchChildVideos', 'individual');
    this.setDisplayLocations();
    this.setInquiries();
    
    if ([true, `true`].includes(this.$route.query.showDisplayLocations)) {
      this.showDisplayLocations();
    } else if ([true, 'true'].includes(this.$route.query.showInquiries)) {
      this.showInquiries();
    }
  },

  mounted () {
    window.getApp.$on('NEW_ALBUM_PHOTO', messageEvent => {
      console.log('------------>>>>>>>', 'Album Photo', messageEvent);
      if (messageEvent.data) {
        const newImage = messageEvent.data;
        
        if (!this.individualPhotos.find(item => item.id === newImage.id)) {
          this.individualPhotos.push(newImage);
        }
      }
    });
  },
  methods: {
    async initialize () {
      let where = { /* _id: { $ne: this.Agency.id }, */ is_admin: false };
      let attributes = 'name,nickname,email,map_sub_id,mapping_id,address,createdAt';
      let populate = [{ path: 'human', select: '_id user' }, { path: 'address.state', select: 'name' }];
      let { error, data } = await getCollection('Agency', true, 0, populate, where, attributes);
      if (error) {
        console.log(error);
        this.snackbar = {
          show: true,
          color: 'red',
          text: 'Failed to load client list'
        };
      } else {
        if (data.length > 0) {
          store.commit('setAgencyList', data);
        }
      }
    },
    getAgencyState (inquiry) {
      if (inquiry && inquiry.badge_identifier) {
        const agency = this.AgencyList.find(x => x.map_sub_id && x.map_sub_id.toString() === inquiry.badge_identifier.toString());
        return agency && agency.address && agency.address.length ? (agency.address[0].state && agency.address[0].state.name ? agency.address[0].state.name : '--') : '--';
      }
      return '--';
    },
    placementChanged () {
      if (['inState', 'selectedStates'].indexOf(this.child.placement) > -1 && this.agencyAddress.state) {
        const state = this.filteredStates.find(x => x.id === this.agencyAddress.state);
        if (state) {
          this.child.display_on_states = [state.id];
        }
      } else if (this.child.placement === 'anyWhere') {
        this.child.display_on_states = [];
      }
      this.changedData();
    },
    changedData (e, isAgencyContactInfoChanged = false) {
      this.selectedData = true;
      if (isAgencyContactInfoChanged) {
        this.$emit('agencyDataChanged');
        this.isAgencyContactInfoChanged = isAgencyContactInfoChanged;
      }
      if (this.parentData.type === 'Individual') {
        this.$emit('onChange');
      }
    },
    formatDateLocal (date) {
      if (!date) return '';
      const [year, month, day] = date.split('-');
      return `${month}/${day}/${year}`;
    },
    parseDate (date) {
      if (!date) return '';
      const [month, day, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    async duplicateEmailChecking () {
      if (this.agencyAddress.email && !(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,5})+$/).test(this.agencyAddress.email.trim())) {
        swal.fire({
          title: 'Please enter a valid email address',
          type: 'warning',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Close',
          allowOutsideClick: false
        });
        return false;
      }
      this.emailFlag = false;
      if (this.agencyAddress.email.length) {
        const emailUrl = `${this.config.WPParams.api.url}pf/v1/emailexists?email=${this.agencyAddress.email}`;
        let where = { 'username': this.agencyAddress.email.trim() };
        const response = await getCollection('User', true, 0, '', where);
        if (response.error) {
          console.log(response.error);
        } else {
          if (response.data && response.data.length) {
            swal.fire({
              title: 'The email already exists',
              type: 'error',
              confirmButtonColor: '#3085d6',
              confirmButtonText: 'Close',
              allowOutsideClick: false
            }).then((result) => {
              this.agencyAddress.email = '';
            });
          } else {
            this.emailFlag = true;
          }
        }
      }
    },
    changeAvatar () {
      this.changedData();
      this.$emit('avatarChange', 'individual');
    },
    uploadPhotos () {
      this.changedData();
      this.$emit('uploadPhotos', 'individual');
    },
    layout () {
      if (this.$refs.individualImages) {
        this.$refs.individualImages.layout('masonry');
      }
    },
    getOptions () {
      return {
        layoutMode: 'masonry',
        masonry: {
          columnWidth: '.photo-item',
        },
        percentPosition: true,
        originLeft: true,
        itemSelector: '.photo-item'
      };
    },
    editPhotoCaption (item, index) {
      this.currentEditPhotoIndex = index;
      this.currentEditPhoto = item.id;
      this.isCaptionEdit = true;
      this.editPhotoItem = item;
    },
    async savePhotoCaption () {
      if (this.currentEditPhotoIndex > -1) {
        let { error, data, status } = await update(
          'Photo',
          this.editPhotoItem,
          this.editPhotoItem.id
        );
        if (error) {
          console.log('error', error);
        } else {
          this.individualPhotos[this.currentEditPhotoIndex] = data;
          this.removePhotoCaptionEdit();
        }
      }
    },
    removePhotoCaptionEdit () {
      this.currentEditPhotoIndex = -1;
      this.currentEditPhoto = null;
      this.isCaptionEdit = false;
      this.editPhotoItem = null;
    },
    async deletePhoto (item) {
      swal.fire({
        title: 'Are you sure?',
        text: 'You won\'t be able to revert this!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(result => {
        if (result.value) {
          (async () => {
            let { error, data, status } = await remove('Photo', item.id);
            if (error) {
              console.log('error', error);
            } else {
              const photosArray = 'individualPhotos';
              const photoIndex = this[photosArray].findIndex(x => x.id === item.id);
              if (photoIndex > -1) {
                this[photosArray].splice(photoIndex, 1);
              }
            }
          })();
        }
      });
    },
    async fetchAgencyData () {
      this.changedData();
      if (this.parentData.agency) {
        let attributes = 'name,address,phone,email,createdAt,_id';
        let { error, data } = await getOne('Agency', this.parentData.agency.id, '', attributes);
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to fetch agency contact information'
          };
        } else {
          this.selectedAgency = data;
          if (this.parentData.agency) {
            if (data.address && data.address.length) {
              this.agencyAddress = {
                ...this.agencyAddress,
                ...{
                  ...data.address[0],
                  ...{ country: data.address[0].country ? data.address[0].country.id : '' },
                  ...{ state: data.address[0].state ? data.address[0].state.id : '' },
                }
              };
            }
            if (data.email && data.email.length) {
              this.agencyAddress = {
                ...this.agencyAddress,
                ...{ email: data.email[0].email }
              };
            }
            if (data.phone && data.phone.length) {
              this.agencyAddress = {
                ...this.agencyAddress,
                ...{ phone: data.phone[0].number }
              };
            }
            if (data.website) {
              this.agencyAddress = {
                ...this.agencyAddress,
                ...{ website: data.website }
              };
            }
            if (!this.agencyAddress.country) {
              this.agencyAddress.country = '5f0af2eb1b61360afbb1aa0c';
            }
          }
        }
      }
    },
    addOtherDisability (e, item, disability) {
      let index = this.child.additional_info.disability.types[disability].items.indexOf(e.target.value);
      if (index === -1) {
        this.child.additional_info.disability.types[disability].items.push(e.target.value);
        this.disabilityItems.push(e.target.value);
      }
    },
    switchTabs (page) {
      if (page === this.currentPage) {
        return;
      }
      let formValid = this.readonly || this.$refs[this.formNames[this.currentPage]].validate();
      if (page && formValid) {
        this.currentPage = page;
        this.childTab = this.childTabs[this.currentPage];
      } else if (!formValid) {
        swal.fire({
          type: 'warning',
          text: 'Please make sure you filled all the mandatory fields for the child',
          showConfirmButton: true
        });
        return;
      }
    },
    save () {
      let formValid = this.$refs[this.formNames[this.currentPage]].validate();

      if (formValid && this.parentData.type === 'Individual' && this.currentPage === 2) {
        if (!this.parentData.agency) {
          formValid = false;
          swal.fire({
            type: 'warning',
            html: `Please choose an organization under contact`,
            showConfirmButton: true
          });
          return;
        }
      }

      if (formValid) {

        if (this.currentPage === this.lastPage) {

          if (this.readonly) {
            return;
          }
          
          if (this.parentData.type === 'Individual') {
            this.$emit('onSubmit', this.child);
          } else {
            /* Remove preference and contact if empty */
            if (!Object.keys(this.child.preference).filter(pref => this.child.preference[pref].length).length) {
              delete this.child.preference;
            }
            if (!Object.keys(this.child.contact).filter(contact => this.child.contact[contact].length).length) {
              delete this.child.contact;
            }
            delete this.child.agencyAddress;
            this.$emit('onSave', this.child);
          }
        } else {
          this.currentPage++;
          this.childTab = this.childTabs[this.currentPage];
        }
        
      } else {
        swal.fire({
          type: 'warning',
          text: 'Please make sure you filled all the mandatory fields for the child',
          showConfirmButton: true
        });
        return;
      }
    },
    cancel () {
      if (this.parentData.type === 'Individual') {
        /* Back to listing */
        this.$router.push({ path: '/children' });
      } else {
        this.$emit('goBack', this.childBackup, this.selectedData || !!(this.child.human[0].first_name));
      }
    },
    addVideo () {
      if (this.readonly) {
        return;
      }
      if (this.$refs.videoAddForm.validate()) {
        this.changedData();
        this.$emit('addVideo', true);
      }
    },
    updateVideoTitle () {
      if (this.readonly) {
        return;
      }
      this.changedData();
      this.$emit('updateVideoTitle', 'individual');
    },
    async setDisplayLocations () {
      if (this.displayLocationsList.length) {
        this.displayLocations = this.displayLocationsBackup = this.displayLocationsList;
      }
    },
    
    async setInquiries () {
      if (this.inquiryList.length && this.child.map_data.user_id) {
        const data = this.inquiryList.filter(x => !x.is_sibling && x.child_id === this.child.map_data.user_id);
        this.inquiries = data;
        this.inquiriesBackup = JSON.parse(JSON.stringify(this.inquiries));
      }
    },
    showInquiries () {
      this.isDisplayInquiries = true;
    },
    showDisplayLocations () {
      this.isDisplayLocation = true;
    },
    filterDisplayLocations () {
      if (this.displayState) {
        if (this.displayState === 'All') {
          this.displayLocations = JSON.parse(JSON.stringify(this.displayLocationsBackup));
        } else {
          this.displayLocations = this.displayLocationsBackup.filter(x => x.address && x.address.length && x.address[0].state && this.displayState === x.address[0].state.name);
        }
      }
    },
    async changeDisplayStatus (item) {
      if (this.readonly) {
        return;
      }
      const payload = JSON.parse(JSON.stringify(item));
      payload.updated_from = 'badge';
      let { error: updateError, data: updateData, status: updateStatus } = await update('Agency', payload, payload.id);
      if (updateError) {
        console.log('updateError', updateError);
      }
    }
  }
};
</script>

<style lang="css" scoped>

.avatar-overlay {
  width: 100%;
  height: 100%;
  background:#00000059;
  position: absolute;
  top: 0;
  bottom: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.title-display{
    padding-top: 6px !important;
  }
  .text-edit-field {
    padding-left: 4px;
    padding-bottom: 6px;
  }
  @media(max-width:576px){
    .or-label{
      padding-top: 0;
    }
  }

.rounded-corner {
    border-radius: 2px;
    border : 2px solid #019d8c !important;
}

.video-listing >>> .youtube-player {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
}

.video-listing >>> .youtube-player iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

</style>


// WEBPACK FOOTER //
// src/pages/Children/singleChild.vue